export default __webpack_public_path__ + "static/media/promotion.e3cc9dad.svg";